import { directiveEntryFormSteps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntryFormSteps.constant'
import { MaintenanceForwardingsRequiredDirectiveStepsData } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import z, { ZodTypeAny } from 'zod'

export const buildDynamicSchema = (requiredDirectiveSteps: MaintenanceForwardingsRequiredDirectiveStepsData) => {
  const keys = Object.keys(requiredDirectiveSteps) as Array<keyof typeof directiveEntryFormSteps>

  const schemas = keys
    .map((key) => directiveEntryFormSteps[key]?.schema)
    .filter(Boolean) as ZodTypeAny[]

  if (schemas.length === 0) return z.object({})
  if (schemas.length === 1) return schemas[0]

  return schemas.reduce((acc, schema) => z.intersection(acc, schema))
}
